import React from 'react';
import { classList } from '../../../../../utils/string.ts';
import { Ad } from './ad.tsx';
import { matchesCohortFromCookie } from '../../../../../utils/cohort.ts';

const displacedStickyAdWidth = 300;

export type DisplacedStickyAdsProps = {
  leftAd: boolean;
  rightAd: boolean;
  isModalOpen?: true;
};

export const DisplacedStickyAds: React.FunctionComponent<
  React.PropsWithChildren<DisplacedStickyAdsProps>
> = props => {
  return (
    <div className="flex justify-center">
      {props.leftAd && (
        <DisplacedStickyAd
          adId="sk_sidebar_left"
          placement="left"
          isModalOpen={props.isModalOpen}
        />
      )}
      <div className="min-w-0 grow-0">{props.children}</div>
      {props.rightAd && (
        <DisplacedStickyAd adId="sk_sidebar" placement="right" isModalOpen={props.isModalOpen} />
      )}
    </div>
  );
};

type DisplacedStickyAdProps = {
  adId: string;
  placement: 'left' | 'right';
  className?: string;
  isModalOpen?: boolean;
};

/**
 * This is used to have an ad aligned with the main content,
 * but actually be visible outside the main content.
 */
const DisplacedStickyAd: React.FunctionComponent<DisplacedStickyAdProps> = props => {
  const { placement, isModalOpen } = props;
  const abTabSetup = matchesCohortFromCookie('sk-AB-tabsetup', '2', '3');
  return (
    <div
      className={classList(
        abTabSetup && 'z-(--z-index-ad-skyscraper)',
        'hidden 2xl:block',
        placement === 'left' && 'mr-4 text-right',
        placement === 'right' && 'ml-4',
        props.className
      )}
      style={(() => {
        switch (placement) {
          case 'left':
            return { width: displacedStickyAdWidth, marginLeft: -1 * displacedStickyAdWidth };
          case 'right':
            return { width: displacedStickyAdWidth, marginRight: -1 * displacedStickyAdWidth };
        }
      })()}
    >
      <div className={classList(isModalOpen ? 'fixed top-0 mt-60' : 'sticky top-4', 'w-[300px]')}>
        <Ad
          adId={props.adId}
          disclaimer={false}
          className={classList('bg-transparent', !isModalOpen && 'pt-10')}
        />
      </div>
    </div>
  );
};
